<template>
  <v-card
    class="mx-auto flex d-flex flex-column mr-3 ml-3"
    width="350"
    elevation="5"
    style="position: relative; margin-top: 40px"
  >
    <v-card-text>
      <v-card
        width="320"
        elevation="10"
        :color="optionColor"
        class="white--text"
        style="position: absolute; margin-top: -45px"
      >
        <v-card-title>
          <v-row>
            <v-col cols="12" class="mb-0 pb-0 justify-center d-flex">
              {{ optionName.toUpperCase() }}
            </v-col>
            <v-col cols="12" class="mt-0 mb-0 pb-0 pt-0 d-flex justify-center">
              <p class="text-h5 mt-2 font-weight-bold">{{ optionPrice }}</p>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-card-text>

    <v-card-text class="flex mt-13">
      <v-list>
        <!-- <v-subheader>Features:</v-subheader> -->
        <v-row class="mt-2">
          <v-col
            cols="12"
            v-for="f in optionFeatures"
            v-bind:key="f"
            class="mt-2 mb-2 pb-0 pt-0 ml-7 d-flex font-weight-regular"
            style="font-size: 1rem"
          >
            <v-icon color="green" class="mr-2">mdi-check</v-icon> {{ f }}
          </v-col>
        </v-row>
      </v-list>

      <div class="mt-5 mb-5">
        <a
          target="_blank"
          rel="noopener noreferrer"
          :href="exampleUrl"
          class="text-decoration-none d-flex justify-center"
        >
          See example
        </a>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-row>
        <v-col cols="12" v-if="!userLoggedIn">
          <p style="font-size: 1rem">
            This option is available only for logged-in users<span
              v-if="proOption"
              class="font-weight-medium"
            >
              with Pro subscription</span
            >
          </p>
          <v-btn
            block
            color="primary"
            class="mt-1"
            href="/login?path=evaluate-ai"
          >
            Sign in
          </v-btn>
          <v-btn block class="mt-2" text href="/register?path=evaluate-ai">
            Sign up
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          class="mt-0 mb-2 pt-0 pb-0"
          v-if="userLoggedIn && proOption && !userCanUseProAi"
        >
          <v-btn
            block
            color="primary"
            class="white--text text-weight-medium"
            v-if="proOption && !$store.getters.canUseProAiReviews"
            to="/gopro"
          >
            Unlock with PRO
          </v-btn>
        </v-col>
        <v-col cols="12" class="mt-0 mb-2 pt-0 pb-2" v-if="userLoggedIn">
          <v-btn
            block
            :color="optionColor"
            @click="selectOption"
            class="white--text text-weight-medium"
            :disabled="proOption && !userCanUseProAi"
          >
            Select
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "PricingOption",
  props: [
    "optionName",
    "optionId",
    "optionPrice",
    "optionColor",
    "optionFeatures",
    "exampleUrl",
    "proOption",
  ],
  data: () => ({
    btnColor: "primary",
    userLoggedIn: false,
    userCanUseProAi: false,
  }),
  methods: {
    selectOption(params) {
      this.$emit("pricingOptionSelected", this.optionId);
    },
  },
  mounted() {
    this.userLoggedIn = this.$store.getters.userLoggedIn;
    this.userCanUseProAi = this.$store.getters.canUseProAiReviews;
  },
};
</script>
